//-------------------------------------------------------------------------------------------------- Imports
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { getTermsAndCond } from "../../methods/Methods";
import _ from "lodash";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import Loading from "../../components/Loading";
import InfoCardComponent from "../../components/InfoCardComponent";
import ListAccordion, { ListAccordionItem } from "../../components/ListAccordion";
import MarkdownPreviewer from "../../common/MarkdownPreviewer";

//-------------------------------------------------------------------------------------------------- View
const TermsAndConditions = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [termsAndCondList, setTermsAndCondList] = useState<ListAccordionItem[]>([]);

    const getTermsAndCondFnt = useCallback(async () => {
        setIsLoading(true);
        await getTermsAndCond(idCliente)
            .then((response) => {
                if (response && response.data && response.data.data) {
                    let faqTypes = response.data.data
                        .filter(elem => elem.type !== "Acerca de") // Filtrar los elementos que no tienen el título "Acerca de"
                        .map((elem, index) => {
                            return {
                                key: index,
                                title: elem.type,
                                children: (
                                    <div>
                                        <MarkdownPreviewer
                                            mdSource={elem.content}
                                            h1Style={{ color: "#0e5ea5", fontSize: 18, fontWeight: 600 }}
                                            h2Style={{ color: "#565656", fontSize: 15, fontWeight: 500 }}
                                            h3Style={{ color: "#373737", fontSize: 14, fontWeight: 500 }}
                                            h4Style={{ color: "#000000", textTransform: "uppercase", fontSize: 16, fontWeight: 500 }}
                                            linkStyle={{ color: "#3198ef", textDecorationLine: "underline" }}
                                        />
                                    </div>
                                ),
                            };
                        });
                    setTermsAndCondList(faqTypes);
                } else {
                    setHasError(true);
                    setMessage("No hay información para mostrar.");
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                setIsLoading(false);
            });
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            getTermsAndCondFnt();
        }
    }, [idCliente, getTermsAndCondFnt])

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Términos y Condiciones"} >
                        <div style={{ marginTop: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    !_.isEmpty(termsAndCondList) ?
                                        <ListAccordion items={termsAndCondList} />
                                        : null
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Exports
export default TermsAndConditions;
